import { useCallback, useEffect, useState } from "react";

// Encapsulates image gallery state + keyboard navigation for the lightbox.
export function useGallery(gallery) {
  const [activeImg, setActiveImg] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  const prev = useCallback(() => setActiveImg((i) => (i - 1 + gallery.length) % gallery.length), [gallery.length]);
  const next = useCallback(() => setActiveImg((i) => (i + 1) % gallery.length), [gallery.length]);

  useEffect(() => {
    if (!lightbox) return;
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "Escape") setLightbox(false);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [lightbox, prev, next]);

  return { activeImg, setActiveImg, lightbox, setLightbox, prev, next };
}
